module.exports = ".nav-link {\n  color: #53f !important; }\n\n.navbar-brand {\n  color: whitesmoke !important; }\n\nhtml {\n  scroll-behavior: smooth !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header/header.component.scss
// module id = ./src/app/shared/header/header.component.scss
// module chunks = main